export const fixNaN = (value) => {
  if (isNaN(value)) return 0
  if (value === Infinity) return 0
  return value
}
